export function Container({
  className,
  children,
  id,
}: {
  className?: string;
  children: React.ReactNode;
  id?: string;
}) {
  return (
    <div
      className={`mx-auto max-w-screen-2xl px-5 lg:px-10 ${className}`}
      id={id}
    >
      {children}
    </div>
  );
}
